<template lang="html">
  <!-- :height="modifiedHeight" -->
  <apexcharts
    ref="chart"
    width="100%"
    type="donut"
    :options="chartOptions"
    :series="series"
  />
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  props: {
    labels: Array,
    series: Array,
    options: Object,
    height: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
      modifiedHeight: this.height
    }
  },
  computed: {
    chartDefault () {
      return {
        chart: {
          height: this.modifiedHeight
        },
        legend: {
          position: 'bottom'
        },
        stroke: {
            width: 3,
        },
        series: this.series,
        labels: this.labels
      }
    },
    chartOptions () {
      return { ...this.chartDefault, ...this.options }
    }
  },
  watch: {
  },
  mounted () {
    this.modifiedHeight = Math.max(this.$refs.chart.$el.clientWidth, this.height)
  }
}
</script>

<style lang="css" scoped>

</style>
